import { CtaButton } from '@/components/astro/cta-button/cta-button';
import * as m from '@/paraglide/messages';
import listenOnTheGo from '@listening/assets/astro/images/new-design-25/features-page/listen-on-the-go.png';

export function ListenOnTheGo() {
  return (
    <section className='mx-auto max-w-[1600px] px-4 py-16 sm:px-6 md:py-24 lg:px-8'>
      <div className='flex flex-col items-center gap-32 lg:flex-row lg:justify-between'>
        {/* <!-- Left section - Image --> */}
        <div className='w-full lg:w-1/2'>
          <img
            alt='Listen on the go feature illustration'
            className='h-auto w-full rounded-2xl'
            src={listenOnTheGo}
          />
        </div>

        {/* <!-- Right section - Content --> */}
        <div className='w-full lg:w-1/2'>
          <div className='max-w-4xl text-center lg:max-w-2xl lg:text-left'>
            {/* <!-- Title --> */}
            <h2 className='mx-auto mb-6 max-w-2xl text-4xl leading-tight font-bold tracking-[-0.02em] lg:mx-0 lg:text-6xl'>
              {m.features_listen_on_go_title()}
            </h2>
            {/* <!-- Description --> */}
            <p className='mx-auto mb-8 max-w-2xl text-lg text-neutral-665 lg:mx-0'>
              {m.features_listen_on_go_description()}
            </p>

            <div className='flex justify-center lg:justify-start'>
              <CtaButton
                className='h-10 bg-royal-50 px-8 py-7 text-xl font-light text-white hover:bg-royal-50/90'
                label={m.features_listen_on_go_cta()}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
